<script>
import { VDialog } from "vuetify/lib";
export default {
  extends: VDialog,
  props: {
    attach: { type: String, default: "#atom-main > div" }
  }
};
</script>

<style scoped>
div .v-dialog__content {
  position: absolute;
}
</style>
